import { Flex, Breadcrumb, Button } from '@applyboard/crystal-ui';

import { ChangeProgramTable, ProgramDetails } from '../components';
import { PageHeader } from '~/components/PageHeader';
import { BreadcrumbItem } from '../types';
import { useApplication } from '~/context';
import {
  CampusFilter,
  IntakeFilter,
  IntakesFilterSummary,
  IntakesPagination,
  QueryFilter,
  Sort,
  StatusFilter,
} from '~/components/Intake';

type DesktopLayoutProps = {
  breadcrumbItems: BreadcrumbItem[];
};

export function DesktopLayout(props: Readonly<DesktopLayoutProps>) {
  const { application } = useApplication();

  const handleCancel = () => {
    window.location.href = `/applications/${application.id}`;
  };

  return (
    <Flex p={10} gap={4} direction="column">
      <Breadcrumb items={props.breadcrumbItems} />
      <Flex justify="between" align="center">
        <PageHeader title="Change Primary Program Intake" />
        <Button intent="secondary" emphasis="outlined" onClick={handleCancel} width="hug">
          Cancel
        </Button>
      </Flex>
      <ProgramDetails lineSplit={false} />
      <Flex gap={2}>
        <Filter as={<QueryFilter />} width="100%" />
        <Filter as={<CampusFilter />} width="auto" />
        <Filter as={<IntakeFilter />} width="auto" />
        <Filter as={<StatusFilter />} width="auto" />
        <Filter as={<Sort showCreatedSort={false} />} width="auto" />
      </Flex>
      <Flex pt={2}>
        <IntakesFilterSummary />
      </Flex>
      <ChangeProgramTable />
      <IntakesPagination />
    </Flex>
  );
}

type FilterProps = {
  as: React.ReactNode;
  width: string;
};

function Filter(props: Readonly<FilterProps>) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
